module.exports = __webpack_public_path__ + "static/img/background-login.538d7415.jpg";